<template>
  <!-- <div> -->
  <div class="circle_box" :ref="`fourth${info.index}`"></div>
  <!-- </div> -->
</template>

<script>
import * as echarts from 'echarts';

const colorList = ['#12FBF7', '#FFAB13', '#E2E2E2', '#FF4013', '#13A1FF'];
const colorListComp = ['#0D4550', '#3C3828', '#3C4857', '#412932', '#174067'];
export default {
  name: 'simgleCircle',
  props: {
    info: {
      default: () => {},
      type: Object,
    },
    // title: {
    //   default: 0,
    //   type: Number,
    // },
  },
  computed: {},
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    info: {
      handler(newVal, oldVal) {
        const { index, baifenbi } = newVal;

        this.$nextTick(() => {
          this.drawCharts(index, baifenbi);
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  methods: {
    drawCharts(index, baifenbi) {
      const ref = `fourth${index}`;
      this.chart = echarts.init(this.$refs[ref]);

      const option = {
        series: {
          name: '',
          type: 'pie',
          radius: ['65%', '85%'],
          avoidLabelOverlap: true,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
            },
            emphasis: {
              show: false,
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          data: [
            {
              value: baifenbi,
              name: '',
              itemStyle: {
                color: colorList[index],
              },
            },
            {
              value: 100 - baifenbi,
              name: '',
              itemStyle: {
                color: colorListComp[index],
              },
            },
          ],
        },
      };
      this.chart.setOption(option);
    },
    // 窗口缩放，echart 动态调整大小
    handleWindowResize() {
      if (!this.chart) return;
      this.chart.resize();
    },
  },
};
</script>

<style lang="less" scoped>
.circle_box {
  width: 24px;
  height: 24px;
}
</style>
